import React, { Component } from "react";

class PoliciesCodesCard extends Component {
  render() {
    return (
      <section className="section testimonial-area ptb_100">
        <div className="container text-center">
          <div className="row w-100 justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 w-100">
              <h2 className="mt-4 mb-4">Policies & Codes</h2>
              <ul
                style={{
                  borderRadius: "5px",
                  alignSelf: "center",
                  marginLeft: "12px",
                }}
              >
                <li>
                  <a
                    className="p-3 row align-items-center justify-content-between"
                    style={{
                      border: "1px solid #bfbfbf",
                      cursor: "pointer",
                    }}
                    href="/termsandconditions"
                  >
                    <p>Terms And Conditions</p>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    className="p-3 row align-items-center justify-content-between"
                    style={{ border: "1px solid #bfbfbf", borderTop: "none" }}
                    href="/interestrate"
                  >
                    <p>Interest Rate Policy</p>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="/privacypolicy"
                    className="p-3 row align-items-center justify-content-between"
                    style={{ border: "1px solid #bfbfbf", borderTop: "none" }}
                  >
                    <p>Privacy Policy</p>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="/loanclosurepolicy"
                    className="p-3 row align-items-center justify-content-between"
                    style={{ border: "1px solid #bfbfbf", borderTop: "none" }}
                  >
                    <p>Loan Closure Policy</p>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="/fairpracticecode"
                    className="p-3 row align-items-center justify-content-between"
                    style={{ border: "1px solid #bfbfbf", borderTop: "none" }}
                  >
                    <p>Fair Practice Code</p>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="/grievancepolicy"
                    className="p-3 row align-items-center justify-content-between"
                    style={{ border: "1px solid #bfbfbf", borderTop: "none" }}
                  >
                    <p>Grievance Redressal Policy</p>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="/scheduleofcharges"
                    className="p-3 row align-items-center
                    justify-content-between"
                    style={{ border: "1px solid #bfbfbf", borderTop: "none" }}
                  >
                    <p>Schedule of Charges</p>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="/referencecontactpolicy"
                    className="p-3 row align-items-center justify-content-between"
                    style={{ border: "1px solid #bfbfbf", borderTop: "none" }}
                  >
                    <p>Reference Contact Policy</p>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PoliciesCodesCard;
